import { useSearchParams } from 'react-router-dom';
import ReferralDiscountsList from '../components/ReferralDiscountsList';
import ReferralsList from '../components/ReferralsList';
import ReferralCodesList from '../components/ReferralCodesList';

const TABS = [
  { key: 'discounts', label: 'Discounts' },
  { key: 'referrals', label: 'Referrals' },
  { key: 'codes', label: 'Custom Referral Codes' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

const ReferralDiscounts = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab: TabKey = TABS.find(tab => tab.key === searchParams.get('tab'))?.key ?? 'discounts';

  const handleTabChange = (tab: TabKey) => {
    if (tab === activeTab) return;
    setSearchParams(tab === 'discounts' ? {} : { tab });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Referral Discounts</h1>
        <p className="text-gray-600">Every referral discount, who holds it, and where it's being used</p>
      </div>

      <div className="border-b border-gray-200 mb-6 overflow-x-auto">
        <nav className="-mb-px flex space-x-6" aria-label="Referral views">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => handleTabChange(tab.key)}
              aria-current={activeTab === tab.key ? 'page' : undefined}
              className={`whitespace-nowrap border-b-2 py-3 px-1 text-sm font-medium ${
                activeTab === tab.key
                  ? 'border-black text-gray-900'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {activeTab === 'referrals' && <ReferralsList />}
      {activeTab === 'codes' && <ReferralCodesList />}
      {activeTab === 'discounts' && <ReferralDiscountsList />}
    </div>
  );
};

export default ReferralDiscounts;
